import styled from 'styled-components'

export const StyledTokenRow = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin: 8px 0;
  width: 100%;
`

export const StyledTokenLabel = styled.div`
  margin-left: 13px;
`

export const StyledTokenIcon = styled.img`
  border: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  border-radius: 50%;
  flex: 0 0 28px;
  height: 28px;
  margin-right: 13px;
  width: 28px;
`

export const StyledTokenValue = styled.div`
  color: ${({ theme }) => theme.colors.textTertiary};
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
`

export const StyledTokenAmount = styled.div`
  color: ${({ theme }) => theme.colors.textTitle};
  font-size: 20px;
  font-weight: 500;
  line-height: 120%;
`
